import React from "react";
import { Text, View } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const normalised = String(value).replace(/[£,\s]/g, "");
  const amount = Number(normalised);

  if (!Number.isFinite(amount)) return String(value);

  return `£${amount.toLocaleString("en-GB", {
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
};

const PrintSection8 = ({ section8 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 8 – Overall Financial Position
      </Text>
      <Text style={PrintApplicationStyles.subcontent}>8.01 Financial Status Questions</Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              8.1 Does your expenditure exceed your income?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.expenditureExceedsIncome === true
                  ? "Yes"
                  : section8?.expenditureExceedsIncome === false
                    ? "No"
                    : section8?.expenditureExceedsIncome === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              8.2 Do your liabilities exceed your assets?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.liabilitiesExceedAssets === true
                  ? "Yes"
                  : section8?.liabilitiesExceedAssets === false
                    ? "No"
                    : section8?.liabilitiesExceedAssets === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              8.3 Do you have any outstanding liabilities?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.outstandingLiabilities === true
                  ? "Yes"
                  : section8?.outstandingLiabilities === false
                    ? "No"
                    : section8?.outstandingLiabilities === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              8.4 Has any property(ies) been repossessed?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.propertyRepossessed === true
                  ? "Yes"
                  : section8?.propertyRepossessed === false
                    ? "No"
                    : section8?.propertyRepossessed === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              8.5 Do you have any properties other than your current address?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.otherProperty === true
                  ? "Yes"
                  : section8?.otherProperty === false
                    ? "No"
                    : section8?.otherProperty === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              8.6 Are you up to date with all your individual and business tax liabilities?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.taxLiabilities === true
                  ? "Yes"
                  : section8?.taxLiabilities === false
                    ? "No"
                    : section8?.taxLiabilities === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section8?.additionalInformation && (
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Additional Information
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section8?.additionalInformation || ""}</Text>
              </View>
            </View>
          )}
        </View>
      </View>

      <Text style={PrintApplicationStyles.subcontent}>8.02 Income</Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Current Monthly Income (net of tax) (£)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{formatCurrency(section8?.currentMonthlyIncome)}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Partner's Monthly Income (net of tax) (£)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{formatCurrency(section8?.partnerMonthlyIncome)}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Do you have any rental income?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.rentalIncome === true
                  ? "Yes"
                  : section8?.rentalIncome === false
                    ? "No"
                    : section8?.rentalIncome === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section8?.rentalIncome === true && (
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Rental Income Amount (£)
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{formatCurrency(section8?.rentalIncomeAmount)}</Text>
              </View>
            </View>
          )}
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Do you have any other income (e.g. investments/pension)?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.otherIncome === true
                  ? "Yes"
                  : section8?.otherIncome === false
                    ? "No"
                    : section8?.otherIncome === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section8?.otherIncome === true && (
            <>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Other Income Source
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section8?.otherIncomeSource || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Other Income Amount (£)
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{formatCurrency(section8?.otherIncomeAmount)}</Text>
                </View>
              </View>
            </>
          )}
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Total Net Monthly Income (£)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{formatCurrency(section8?.netMonthlyIncome)}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Household & Utilities Expenditure per Month (£)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{formatCurrency(section8?.householdExpenditurePerMonth)}</Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        8.03 Assets and Liabilities - Residential
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Do you have a residential mortgage?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.residentialMortgage === true
                  ? "Yes"
                  : section8?.residentialMortgage === false
                    ? "No"
                    : section8?.residentialMortgage === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section8?.residentialMortgage === true && (
            <>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Lender
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{section8?.residentialMortgageLender || ""}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Monthly Repayment Amount (£)
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{formatCurrency(section8?.residentailMortgageAmount)}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  House Value (£)
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{formatCurrency(section8?.residentialHouseValue)}</Text>
                </View>
              </View>
              <View style={PrintApplicationStyles.inputRow}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  Total Amount Outstanding (£)
                </Text>
                <View style={PrintApplicationStyles.inputBox}>
                  <Text>{formatCurrency(section8?.residentialOutstandingAmount)}</Text>
                </View>
              </View>
            </>
          )}
        </View>
      </View>

      <Text style={PrintApplicationStyles.subcontent}>
        8.04 Outstanding Loans or Credit Cards
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Do you have any outstanding loans or credit cards?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.outstandindLoansOrCreditCards === true
                  ? "Yes"
                  : section8?.outstandindLoansOrCreditCards === false
                    ? "No"
                    : section8?.outstandindLoansOrCreditCards === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section8?.outstandingLoandsOrCreditCardDetails &&
            section8.outstandingLoandsOrCreditCardDetails.length > 0 && (
              <>
                <View style={PrintApplicationStyles.tableHeader}>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1.5 }}
                  >
                    Type
                  </Text>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1.5 }}
                  >
                    Lender
                  </Text>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                  >
                    Monthly Repayment (£)
                  </Text>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                  >
                    Outstanding (£)
                  </Text>
                </View>
                {section8.outstandingLoandsOrCreditCardDetails.map(
                  (loan, index) => (
                    <View key={index} style={PrintApplicationStyles.tableRow}>
                      <Text
                        style={{
                          ...PrintApplicationStyles.tableCell,
                          flex: 1.5,
                        }}
                      >
                        {loan.type || ""}
                      </Text>
                      <Text
                        style={{
                          ...PrintApplicationStyles.tableCell,
                          flex: 1.5,
                        }}
                      >
                        {loan.lender || ""}
                      </Text>
                      <Text
                        style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                      >
                        {formatCurrency(loan.monthlyAmount)}
                      </Text>
                      <Text
                        style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                      >
                        {formatCurrency(loan.outstandingAmount)}
                      </Text>
                    </View>
                  ),
                )}
              </>
            )}
        </View>
      </View>

      <Text style={PrintApplicationStyles.subcontent}>
        8.05 Buy-to-Let (BTL) Mortgages
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Do you have a BTL mortgage?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.BTLMortage === true
                  ? "Yes"
                  : section8?.BTLMortage === false
                    ? "No"
                    : section8?.BTLMortage === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section8?.BTLMortageDetails &&
            section8.BTLMortageDetails.length > 0 && (
              <>
                <View style={PrintApplicationStyles.tableHeader}>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}
                  >
                    Lender
                  </Text>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                  >
                    Monthly Repayment (£)
                  </Text>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                  >
                    Outstanding (£)
                  </Text>
                </View>
                {section8.BTLMortageDetails.map((btl, index) => (
                  <View key={index} style={PrintApplicationStyles.tableRow}>
                    <Text
                      style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}
                    >
                      {btl.lender || ""}
                    </Text>
                    <Text
                      style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                    >
                      {formatCurrency(btl.monthlyAmount)}
                    </Text>
                    <Text
                      style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                    >
                      {formatCurrency(btl.outstandingAmount)}
                    </Text>
                  </View>
                ))}
              </>
            )}
        </View>
      </View>

      <Text style={PrintApplicationStyles.subcontent}>
        8.06 Debt Management Plan
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Are you currently in a debt management plan?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.debtManagementPlan === true
                  ? "Yes"
                  : section8?.debtManagementPlan === false
                    ? "No"
                    : section8?.debtManagementPlan === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section8?.debtManagementPlanDetails &&
            section8.debtManagementPlanDetails.length > 0 && (
              <>
                <View style={PrintApplicationStyles.tableHeader}>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}
                  >
                    Practitioner Name
                  </Text>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                  >
                    Monthly Repayment (£)
                  </Text>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                  >
                    Outstanding (£)
                  </Text>
                </View>
                {section8.debtManagementPlanDetails.map((dmp, index) => (
                  <View key={index} style={PrintApplicationStyles.tableRow}>
                    <Text
                      style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}
                    >
                      {dmp.practitionerName || ""}
                    </Text>
                    <Text
                      style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                    >
                      {formatCurrency(dmp.monthlyAmount)}
                    </Text>
                    <Text
                      style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                    >
                      {formatCurrency(dmp.outstandingAmount)}
                    </Text>
                  </View>
                ))}
              </>
            )}
        </View>
      </View>

      <Text style={PrintApplicationStyles.subcontent}>
        8.07 Outstanding Financial Services Debt
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Do you have any outstanding financial services debt?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section8?.outstandingFinancialServicesDebt === true
                  ? "Yes"
                  : section8?.outstandingFinancialServicesDebt === false
                    ? "No"
                    : section8?.outstandingFinancialServicesDebt === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section8?.outstandingFinancialServicesDebtDetails &&
            section8.outstandingFinancialServicesDebtDetails.length > 0 && (
              <>
                <View style={PrintApplicationStyles.tableHeader}>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 2 }}
                  >
                    To Whom
                  </Text>
                  <Text
                    style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                  >
                    Amount (£)
                  </Text>
                </View>
                {section8.outstandingFinancialServicesDebtDetails.map(
                  (fsDebt, index) => (
                    <View key={index} style={PrintApplicationStyles.tableRow}>
                      <Text
                        style={{
                          ...PrintApplicationStyles.tableCell,
                          flex: 2,
                        }}
                      >
                        {fsDebt.to || ""}
                      </Text>
                      <Text
                        style={{ ...PrintApplicationStyles.tableCell, flex: 1 }}
                      >
                        {formatCurrency(fsDebt.amount)}
                      </Text>
                    </View>
                  ),
                )}
              </>
            )}
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        8.08 Financial Summary
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Total Assets (£)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{formatCurrency(section8?.totalAssets)}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Total Liabilities (£)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{formatCurrency(section8?.totalLiabilities)}</Text>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default PrintSection8;
